import { useMatches } from '@tanstack/react-router';

export default function useIsPublicRoute() {
  const match = useMatches().at(-1);
  return match?.routeId.startsWith('/_public/') ?? false;
}
